const ks = `

<p>和值 ：开奖号码相加之和，范围3~18。</p>

<p>和值大小：和值大于等于11为大，和值小于等于10为小。</p>

<p>和值单双 : 和值奇数为单，和值偶数为双。</p>

<p>遗漏期数：自上期开出到本期间隔的期数。</p>

<p>出现次数：统计周期内，某个号码的累计出现次数。</p>

<p>最大遗漏：是指统计周期内所有遗漏值的最大值。</p>

<p>最大连出：是指统计周期内所有连出值的最大值。</p>


`


export default {
  ks
}


// WEBPACK FOOTER //
// ./src/pages/Trend/Hezhizoushi/helpers/tips.js